const componentsSchedulePickerEn = {
  // Form labels
  clearAll: 'Clear',
  daysOfMonthLabel: 'Days of Month',
  daysOfWeekLabel: 'Days of Week',
  frequency: 'Frequency',
  frequencyOptions: {
    DAILY: 'Daily',
    MONTHLY: 'Monthly',
    WEEKLY: 'Weekly',
  },
  selectAll: 'Select All',
  time: 'Time',

  // Days of week
  daysOfWeek: {
    FRI: 'Fri',
    MON: 'Mon',
    SAT: 'Sat',
    SUN: 'Sun',
    THU: 'Thu',
    TUE: 'Tue',
    WED: 'Wed',
  },

  // Action buttons
  save: 'Save',
  saving: 'Saving...',
  update: 'Update',

  // Display format
  display: {
    daily: 'Daily at {{time}}',
    monthly: 'Monthly on {{days}} at {{time}}',
    weekly: 'Every {{days}} at {{time}}',
  },

  // Validation errors
  errors: {
    daysOfMonthRequired: 'Please select at least one day',
    daysOfWeekRequired: 'Please select at least one day',
    timeRequired: 'Please enter a time',
  },
};

export default componentsSchedulePickerEn;
